import FilterBar from './FilterBar';
import FilterSection from './FilterSection';
import FilterItem from './FilterItem';
import FilterToggle from './FilterToggle';
import UnifiedFilterBar from './UnifiedFilterBar';
import FilterRenderer from './FilterRenderer';
import { useFilterBarState } from './useFilterBarState';
import {
  FILTER_TYPES,
  PAGE_FILTER_PRESETS,
  getFilterType,
  getFilterWidth,
  getFilterCacheKey,
  validateFilterConfig,
  normalizeFilterConfigs,
} from './filterConfig';

// Attach sub-components to FilterBar for convenient compound component usage
FilterBar.Section = FilterSection;
FilterBar.Item = FilterItem;
FilterBar.Toggle = FilterToggle;

// Legacy exports (compound component pattern)
export { FilterBar, FilterSection, FilterItem, FilterToggle };

// Unified filter bar exports (configuration-driven pattern)
export {
  UnifiedFilterBar,
  FilterRenderer,
  useFilterBarState,
  FILTER_TYPES,
  PAGE_FILTER_PRESETS,
  getFilterType,
  getFilterWidth,
  getFilterCacheKey,
  validateFilterConfig,
  normalizeFilterConfigs,
};

export default FilterBar;
